import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=85042792&"
import script from "./UserCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserCard.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./UserCard.vue?vue&type=style&index=0&id=85042792&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports